  /*============Get Auth Controller
   ================================*/
  angular
  .module('vppApp')
  .controller('getAuthBSOTController', getAuthBSOTController);

  getAuthBSOTController.$inject = ['$scope', 'titlecaseFilter', '$rootScope', '$state', 'apiFactory', 'AuthenticationService', 'CustomerService', 'GetAuthDetailsService', 'ProgramInfoService', 'vppConfig', 'DTMTrackerService', 'TimeOutService'];

  function getAuthBSOTController($scope, titlecaseFilter, $rootScope, $state, apiFactory, AuthenticationService, CustomerService, GetAuthDetailsService, ProgramInfoService, vppConfig, DTMTrackerService, TimeOutService) {
    // console.log('getAuthBSOTController() ', $scope.id);
    var accountId = AuthenticationService.getAuthenticatedID(),
    _getBSOTEmail = AuthenticationService.getUserEmail(),
    _programData = $scope.id,
    _programCode = $scope.id.code,
    _programID = $scope.id.programID,
    _updateAccountFor = vppConfig.folderPath,
    _authenticationContentPath = vppConfig.authorizationContentPath;

    $scope.showEmailField = false;
    $scope.bsotcomplete = false;
    $scope.entitlementsExceededBSOT = false;
    apiFactory.authProgram(accountId, _programID).then(function (response) {
      // console.log('authprogram response', _getBSOTEmail);

      $scope.purchaserRelationships = response.data.purchaserRelationship;
      $scope.remainingEntitlements = response.data.remainingEntitlements;
      $scope.showRemainingAuths = response.data.remainingAuths;
      $scope.userSuspension = response.data.suspension;
      //console.log("useTPL " + $scope.useTPL);
      /*
       if ($state.current.name === 'get-auth') {
       DTMTrackerService.directCall('get-auth-start');
       }*/
      if ($scope.remainingEntitlements <= 0) {
        $scope.entitlementsExceededBSOT = true;
      }
    }, function (response) {
      //console.log('authprogram error', response);

      if (response.data.errors[0].errorCode === '9050') {
        $scope.entitlementsExceededBSOT = true;
      }

      TimeOutService.checkAuthError(response);
    });

    var savedData = {
      submitBSOTData: {
        programID: _programID,
        programCode: _programCode,
        authDetails: {
          email: null,
          vin: null,
          phone: null
        },
        relationship: null,
        moduleDetails: {
          govtempauth: {
            govEmployee: null
          }
        },
        emailAddress: _getBSOTEmail,
        secondaryPassword: null
      }
    };

    function buildBSOTAuthObj(bsotFormData) {
      // BSOT Email
      savedData.submitBSOTData.authDetails.email = bsotFormData.authDetails.email;
      // BSOT VIN
      savedData.submitBSOTData.authDetails.vin = bsotFormData.authDetails.vin;
      // BSOT Phone
      savedData.submitBSOTData.authDetails.phone = bsotFormData.authDetails.phoneNumber;
      // BSOT relationship
      savedData.submitBSOTData.relationship = bsotFormData.relationship;
      // BSOT GovEmployee
      savedData.submitBSOTData.moduleDetails.govtempauth.govEmployee = bsotFormData.govtEmployee;
      
      savedData.submitBSOTData.secondaryPassword = $scope.userSuspension === true ? bsotFormData.secondaryPassword : null;
      // console.log(" Formed~~ ", savedData.submitBSOTData);

    }
    ;
    	$scope.isBSOTComplete = function (){
        return $scope.bsotcomplete;
    };

    // SUBMIT BSOT
    $scope.submitBSOT = function (user) {
      $scope.responsePending = true;
      buildBSOTAuthObj(user);
      // console.log('User Form data', user);
      // console.log('submit data', savedData.submitBSOTData);     
      apiFactory.authorization(accountId, angular.toJson(savedData.submitBSOTData)).then(function successCallback(response) {
        $scope.authresponse = response.data;
        var authNum = response.data.authorizationNumber;
        $scope.bsotcomplete = true;
        // DTMTrackerService.updatePageLoadData('authCode', authNum);
        DTMTrackerService.directCall('get-auth-complete');
        delete $scope.responsePending;
      }, function errorCallback(response) {
        // console.log(response.data.errors);
        $scope.serverError = response.data.errors;
        TimeOutService.checkAuthError(response);
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
    };
  }
  ;